export default __webpack_public_path__ + "static/media/mtt3.8492c51d.jpg";